import "@/assets/scss/AboutUs.scss";
import React from "react";

// Team member data
const leadership = [
	{
		name: "Alex Sunday",
		position: "President",
		image: "/images/team/Sunday-headshot.jpg",
		affliation: "Harvard University",
	},
	{
		name: "Omenma Abengowe",
		position: "Chief Legal Officer",
		image: "/images/team/Abengowe-headshot.png",
		affliation: "Harvard University",
	},

	{
		name: "Aaron Shah",
		position: "Chief Financial Officer",
		image: "/images/team/Shah-headshot.png",
		affliation: "UC Berkeley",
	},

	{
		name: "Emma Oyakhire",
		position: "Chief Technology Officer",
		image: "/images/team/Oyakhire-headshot.jpg",
		affliation: "Harvard University",
	},
	// Add more leadership team members...
];

const educators = [
	{
		name: "Odusanya Olalekan Adeola",
		position: "Chemistry Educator",
		image: "/images/team/Adeola-headshot.jpg",
		affliation: "Daglore Model College",
	},
	{
		name: "Folarin Ademola",
		position: "Mathematics Educator",
		image: "/images/team/Ademola-headshot.jpg",
		affliation: "Sonmori Senior Comprehensive School",
	},

	{
		name: "Adesina Kehinde",
		position: "Biology Educator",
		image: "/images/team/Kehinde-headshot.png",
		affliation: " Lagos State Teaching Service Commission ",
	},

	{
		name: "Olowo Esther",
		position: "English Language Educator",
		image: "/images/team/Esther-headshot.jpg",
		affliation: "Lagos State Teaching Service Commission  ",
	},

	{
		name: "Olawale Gbenusola",
		position: "Commerence Educator",
		image: "/images/team/Gbenusola-headshot.jpg",
		affliation: "Lagos State Teaching Service Commission  ",
	},

	{
		name: "Adeyemo Mayowa",
		position: "English Language Educator",
		image: "/images/team/Mayowa-headshot.jpg",
		affliation: "English with RMG",
	},

	{
		name: "Shittu Moh-Al-Ameen",
		position: "Mathematics Educator",
		image: "/images/team/Moh-Al-Ameen-headshot.jpg",
		affliation: "Shittu Mathematics Class",
	},

	{
		name: "Olabisi Olawoye",
		position: "Chemistry Educator",
		image: "/images/team/Olawoye-headshot.jpg",
		affliation: "Ipaja Junior College / Elias International Schools",
	},
];

function TeamMember({ name, position, image, affliation }) {
	return (
		<div className="team-member">
			<div className="team-member__photo">
				<img src={image} alt={name} />
			</div>
			<h3 className="team-member__name">{name}</h3>
			<h4 className="team-member__position">{position}</h4>
			<p className="team-member__affiliation">{affliation}</p>
		</div>
	);
}

function Team() {
	return (
		<div className="team">
			<h1 className="team__title">Our Team</h1>

			<section className="team__leadership">
				<h2>Leadership Team</h2>
				<div className="team__grid">
					{leadership.map((member, index) => (
						<TeamMember
							key={index}
							name={member.name}
							position={member.position}
							affliation={member.affliation}
							image={member.image}
						/>
					))}
				</div>
			</section>

			<section className="team__educators">
				<h2>Education Team</h2>
				<div className="team__grid">
					{educators.map((member, index) => (
						<TeamMember
							key={index}
							name={member.name}
							position={member.position}
							affliation={member.affliation}
							image={member.image}
						/>
					))}
				</div>
			</section>
		</div>
	);
}

export default Team;
